import JJFlyer from "../assets/images/jj-flyer.png";

const jj_flyer = {
    slug: "JJ_Detailing_Flyer",
    sections: [
        {
            elements: [
                { type: "title-prc", content: "Flyer recto/verso JJ Detailing" },
                { type: "tex-prc", content: "Conception d'un support de communication print pour promouvoir l'activité professionnelle d'une entreprise de detailing automobile." },
                { type: "imageTitle", src: JJFlyer, alt: "Flyer JJ Detailing" }
            ]
        },
        {
            elements: [
                { type: "title", content: "Suite de la collaboration" },
                { type: "text", content: "Après le succès de la carte de visite, JJ Detailing est revenu vers moi pour un nouveau projet : la création d'un flyer promotionnel. L'objectif était de disposer d'un support imprimé permettant de présenter l'ensemble des services proposés et d'attirer de nouveaux clients." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Processus collaboratif" },
                { type: "text", content: "Ce projet s'est déroulé dans un esprit de collaboration étroite. Le client m'a transmis ses besoins spécifiques ainsi que les textes à intégrer pour chaque service. De mon côté, je me suis concentré sur le design et la mise en forme du flyer, en veillant à créer une composition visuelle attractive et efficace." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Structure du flyer" },
                { type: "text", content: "Le format recto/verso a été choisi pour optimiser l'espace disponible. Le recto présente une accroche visuelle impactante avec les services phares et les coordonnées de l'entreprise. Le verso détaille l'ensemble des prestations : lavage extérieur, nettoyage intérieur, polish, traitement céramique, etc., organisés de manière claire et hiérarchisée." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Cohérence visuelle" },
                { type: "text", content: "Le design du flyer s'inscrit dans la continuité de l'identité visuelle établie avec la carte de visite. La palette de couleurs, la typographie et les éléments graphiques assurent une cohérence parfaite entre tous les supports de communication. Des photos de véhicules détaillés illustrent la qualité du travail proposé." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Utilisation et diffusion" },
                { type: "text", content: "Le flyer, imprimé au format A5 pour une prise en main optimale, est distribué aux clients potentiels, déposé chez des commerces partenaires et utilisé lors d'événements automobiles locaux. Cet outil de communication permet à JJ Detailing de présenter efficacement son offre et de développer sa clientèle." }
            ]
        }
    ]
};

export default jj_flyer;